export const addStructuredData = (schema: object) => {
  const schemaScript = document.createElement('script');

  schemaScript.type = 'application/ld+json';
  schemaScript.text = JSON.stringify(schema);
  document.head.appendChild(schemaScript);
};
